export const TitleSection = {
    locker: 'dd_cajafuerte_title',
    finish: 'dd_acabados_title',
    intAccesories: 'dd_accesoriosinteriores_title'
}